import React from 'react';
import { useNavigate } from "react-router-dom";
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { SDrawer, STitle, SListItem } from './styles';

const MenuItem = ({ label, to, openPage }) => {
    return (<SListItem>
        <ListItemButton onClick={() => openPage(to)}>
            <ListItemText>{label}</ListItemText>
        </ListItemButton>
    </SListItem>)
}

const MenuTitle = ({ title, menu, openPage }) => {
    return (<>
        <STitle variant="h6" gutterBottom>{title}</STitle>
        <List>
            {menu.map((m,i) => {
                return <MenuItem key={`m${i}`} {...m} openPage={openPage} />
            })}
        </List>
    </>)
}

const Menu = ({ openMenu, setOpenMenu, menu=[] }) => {
    const navigate = useNavigate();

    const openPage = (page) => {
        navigate(page);
        setOpenMenu(false);
    }

    return (<SDrawer anchor="right" open={openMenu} onClose={() => setOpenMenu(false)}>
        <List>
            {menu.map((m,i) => {
                if (m.title) {
                    return <MenuTitle key={`t${i}`} title={m.title} menu={m.menu} openPage={openPage} />
                }
                return <MenuItem key={`m${i}`} {...m} openPage={openPage} />
            })}
        </List>
    </SDrawer>)
}

export default Menu;